const productContent = document.getElementsByClassName(
  'product__content'
)[0];
const sprStarRating =
  document.getElementsByClassName('spr-starrating')[0];

if (!productContent && !sprStarRating) {
  if (productContent.classList.contains('text-center')) {
    sprStarRating.style.justifyContent = 'center';
  } else if (productContent.classList.contains('text-right')) {
    sprStarRating.style.justifyContent = 'flex-end';
  } else if (productContent.classList.contains('text-left')) {
    sprStarRating.style.justifyContent = 'flex-start';
  }
}


// --- Reactivación 75% promo banner (added 2026-09-16) ------------------------
// Shows the discounted first-order price on the PDP when the shopper arrives via
// ?promo=reactiva75 (the WhatsApp winback link). Additive + param-guarded, so
// normal visitors never see it. The discount itself still applies at checkout.
(function () {
  try {
    var params = new URLSearchParams(window.location.search);
    if (params.get('promo') !== 'reactiva75') return;

    var inject = function (allowFallback) {
      if (document.getElementById('reactiva-promo-banner')) return true;
      var anchor = document.querySelector('.loop-widget-purchase-options-container');
      if (!anchor && allowFallback) anchor = document.querySelector('.product__form') || document.querySelector('button[name="add"]');
      if (!anchor || !anchor.parentNode) return false;
      var b = document.createElement('div');
      b.id = 'reactiva-promo-banner';
      b.style.cssText = 'margin:0 0 14px;padding:12px 16px;border-radius:12px;background:#eef3e6;border:1px solid #bcc0a3;';
      b.innerHTML =
        '<div style="font-family:inherit;font-weight:600;color:#3f4a2e;font-size:14px;">🎁 Reactivación 75% OFF activada</div>' +
        '<div style="font-family:inherit;color:#3f4a2e;font-size:13px;margin-top:4px;line-height:1.5;">' +
          'Se aplica a tu suscripción automáticamente al finalizar la compra.' +
        '</div>';
      anchor.parentNode.insertBefore(b, anchor);
      return true;
    };

    var n = 0;
    var iv = setInterval(function () {
      var allowFallback = n >= 15; // wait ~4.5s for the async Loop widget before falling back
      if (inject(allowFallback) || ++n > 40) clearInterval(iv);
    }, 300);
    inject(false);
  } catch (e) {}
})();
